module.exports = __webpack_public_path__ + "static/media/start-screen-logo.eb559305.png";